import React from "react";
import {useCategories} from "../hooks/useCategory";
import {Category} from "../types";
import {NavLink} from "react-router";
import "../styles/CategoryList.scss";
import {getGeneralAverage} from "../utils/getGeneralAverage";


export const CategoryList: React.FC = () => {
    const {categories, isLoading} = useCategories();

    if (isLoading || !categories) return (<div></div>);

    return (
        <div id={"category-list"}>
            <NavLink to={"/"} className={({isActive}) => isActive ? "flex-row center category-item isActive" : "flex-row center category-item"}>Moyenne générale <br/>{getGeneralAverage(categories)}</NavLink>
            {categories.map((category: Category) => (
                <NavLink
                    key={category.name}
                    to={"/category/" + category.category}
                    className={({isActive}) => isActive ? "flex-row center category-item isActive" : "flex-row center category-item"}
                >
                    {category.category} <br/> coeff: {category.coefficient} <br/> {category.weighted_average !== -1 ? category.weighted_average : "n/a"}
                </NavLink>
            ))}
        </div>
    )
}